import { render, staticRenderFns } from "./selection_lot.vue?vue&type=template&id=541af326&scoped=true&"
import script from "./selection_lot.vue?vue&type=script&lang=js&"
export * from "./selection_lot.vue?vue&type=script&lang=js&"
import style0 from "./selection_lot.vue?vue&type=style&index=0&id=541af326&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541af326",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VBtn,VCard,VIcon})
